<div class="n-menu-footer" [ngClass]="{ 'n-nav-hidden': !menuVisivel }">
  <!-- Botão Toggle Menu -->
  <button
    class="n-nav-toggle"
    [ngClass]="{ 'n-nav-toggle-collapsed': !menuVisivel }"
    (click)="toggleMenu()"
    [attr.aria-label]="(menuVisivel ? 'GLOBAL.NAV.OCULTAR_MENU' : 'GLOBAL.NAV.EXIBIR_MENU') | translate"
    [pTooltip]="(menuVisivel ? 'GLOBAL.NAV.OCULTAR_MENU' : 'GLOBAL.NAV.EXIBIR_MENU') | translate"
    tooltipPosition="top"
  >
    <i [ngClass]="menuVisivel ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></i>
  </button>

  <!-- Grid com Ícones Visíveis + Botão Sanduíche -->
  <div class="grid w-full">
    <!-- ITENS VISÍVEIS -->
    @for (item of visibleItems(); track item.label) {
      <div class="col flex align-items-center justify-content-center">
        <div
          class="n-menu-icon"
          [attr.data-tour]="item.tourAnchor || null"
          [ngClass]="{ 'n-menu-icon-selected m-0': selected === item }"
          (click)="select(item)"
          [pTooltip]="(item.labelKey ? (item.labelKey | translate) : item.label)"
          tooltipPosition="top"
        >
          <i class="{{ item.icon }} n-icon" [ngClass]="{ 'n-icon-selected': selected === item }"></i>
        </div>
      </div>
    }

    <!-- BOTÃO MENU SANDUÍCHE (se houver overflow) -->
    @if (hasOverflow()) {
      <div class="col flex align-items-center justify-content-center">
        <div
          class="n-menu-icon n-menu-icon-overflow"
          data-tour="nav-overflow"
          (click)="popover.toggle($event)"
          [pTooltip]="'GLOBAL.NAV.MAIS_OPCOES' | translate"
          tooltipPosition="top"
        >
          <i class="pi pi-bars n-icon"></i>
        </div>
      </div>
    }
  </div>
</div>

<!-- OVERLAY PANEL (Menu Overflow) -->
<p-popover #popover [dismissable]="true" styleClass="n-overflow-menu">
  <ng-template pTemplate="content">
    <div class="n-overflow-menu-content">
      @for (item of overflowItems(); track item.label) {
        <div
          class="n-overflow-menu-item"
          [attr.data-tour]="item.tourAnchor || null"
          [ngClass]="{ 'n-overflow-menu-item-selected': selected === item }"
          (click)="select(item); popover.hide()"
        >
          <i class="{{ item.icon }} n-overflow-icon"></i>
          <span class="n-overflow-label">{{ (item.labelKey ? (item.labelKey | translate) : item.label) }}</span>
        </div>
      }
    </div>
  </ng-template>
</p-popover>
